"use strict";
/*
 * Created on 07 04 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../../core/model/DomainObject");
/**
 * <p>
 *     This class serves to hold precomputed data of sellout identification overview, but for leaf categories (categories without children).
 *     We do not want to compute data for each category of tree because data showed to user depends on user's categories and aggregated sums
 *     showed to user should only include data of particular subtree.
 * </p>
 *
 * <p>
 *     <b>Data based on this entity are persisted within data storage.</b>
 * </p>
 *
 * @author JMe
 */


var SelloutIdentificationOverview =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutIdentificationOverview, _DomainObject_1$Domai);

  /**
   * @param id internal id of overview data
   * @param categoryId {@link ISelloutIdentificationOverview#categoryId}
   * @param dataPerCategory {@link ISelloutIdentificationOverview#dataPerCategory}
   */
  function SelloutIdentificationOverview(id, categoryId, dataPerCategory) {
    var _this;

    _classCallCheck(this, SelloutIdentificationOverview);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutIdentificationOverview).call(this));
    _this.id = id;
    _this.categoryId = categoryId;
    _this.dataPerCategory = dataPerCategory;
    return _this;
  }

  return SelloutIdentificationOverview;
}(DomainObject_1.DomainObject);

exports.SelloutIdentificationOverview = SelloutIdentificationOverview;